// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__Mv8mQ","container":"Modal_container__0rUz3","closeBtn":"Modal_closeBtn__59nyv","component":"Modal_component__VyQBi"};